import React, { Component } from 'react'
import $ from 'jquery'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'

import images from '../../../config/images'
import '../../../stylesheets/about.css'

class About extends Component {
	componentDidMount() {
		var initPhotoSwipeFromDOM = function(gallerySelector) {
			// parse slide data (url, title, size ...) from DOM elements
			// (children of gallerySelector)
			var parseThumbnailElements = function(el) {
				var thumbElements = el.childNodes,
					numNodes = thumbElements.length,
					items = [],
					figureEl,
					linkEl,
					size,
					item

				for (var i = 0; i < numNodes; i++) {
					figureEl = thumbElements[i] // <figure> element

					// include only element nodes
					if (figureEl.nodeType !== 1) {
						continue
					}

					linkEl = figureEl.children[0] // <a> element
					size = linkEl.getAttribute('data-size').split('x')

					// create slide object
					item = {
						src: linkEl.getAttribute('href'),
						w: parseInt(size[0], 10),
						h: parseInt(size[1], 10),
					}

					if (figureEl.children.length > 1) {
						// <figcaption> content
						item.title = figureEl.children[1].innerHTML
					}

					if (linkEl.children.length > 0) {
						// <img> thumbnail element, retrieving thumbnail url
						item.msrc = linkEl.children[0].getAttribute('src')
					}

					item.el = figureEl // save link to element for getThumbBoundsFn
					items.push(item)
				}

				return items
			}

			// find nearest parent element
			var closest = function closest(el, fn) {
				return el && (fn(el) ? el : closest(el.parentNode, fn))
			}

			// triggers when user clicks on thumbnail
			var onThumbnailsClick = function(e) {
				e = e || window.event
				e.preventDefault ? e.preventDefault() : (e.returnValue = false)

				var eTarget = e.target || e.srcElement

				// find root element of slide
				var clickedListItem = closest(eTarget, function(el) {
					return el.tagName && el.tagName.toUpperCase() === 'FIGURE'
				})

				if (!clickedListItem) {
					return
				}

				// find index of clicked item by looping through all child nodes
				// alternatively, you may define index via data- attribute
				var clickedGallery = clickedListItem.parentNode,
					childNodes = clickedListItem.parentNode.childNodes,
					numChildNodes = childNodes.length,
					nodeIndex = 0,
					index

				for (var i = 0; i < numChildNodes; i++) {
					if (childNodes[i].nodeType !== 1) {
						continue
					}

					if (childNodes[i] === clickedListItem) {
						index = nodeIndex
						break
					}
					nodeIndex++
				}

				if (index >= 0) {
					// open PhotoSwipe if valid index found
					openPhotoSwipe(index, clickedGallery)
				}
				return false
			}

			// parse picture index and gallery index from URL (#&pid=1&gid=2)
			var photoswipeParseHash = function() {
				var hash = window.location.hash.substring(1),
					params = {}

				if (hash.length < 5) {
					return params
				}

				var vars = hash.split('&')
				for (var i = 0; i < vars.length; i++) {
					if (!vars[i]) {
						continue
					}
					var pair = vars[i].split('=')
					if (pair.length < 2) {
						continue
					}
					params[pair[0]] = pair[1]
				}

				if (params.gid) {
					params.gid = parseInt(params.gid, 10)
				}

				return params
			}

			var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
				var pswpElement = document.querySelectorAll('.pswp')[0],
					gallery,
					options,
					items

				items = parseThumbnailElements(galleryElement)

				// define options (if needed)
				options = {
					// define gallery index (for URL)
					galleryUID: galleryElement.getAttribute('data-pswp-uid'),

					getThumbBoundsFn: function(index) {
						// See Options -> getThumbBoundsFn section of documentation for more info
						var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect()

						return {
							x: rect.left,
							y: rect.top + pageYScroll,
							w: rect.width,
						}
					},
				}

				// PhotoSwipe opened from URL
				if (fromURL) {
					if (options.galleryPIDs) {
						// parse real index when custom PIDs are used
						// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
						for (var j = 0; j < items.length; j++) {
							if (items[j].pid === index) {
								options.index = j
								break
							}
						}
					} else {
						// in URL indexes start from 1
						options.index = parseInt(index, 10) - 1
					}
				} else {
					options.index = parseInt(index, 10)
				}

				// exit if index not found
				if (isNaN(options.index)) {
					return
				}

				if (disableAnimation) {
					options.showAnimationDuration = 0
				}

				// Pass data to PhotoSwipe and initialize it
				gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
				gallery.init()
			}

			// loop through all gallery elements and bind events
			var galleryElements = document.querySelectorAll(gallerySelector)

			for (var i = 0, l = galleryElements.length; i < l; i++) {
				galleryElements[i].setAttribute('data-pswp-uid', i + 1)
				galleryElements[i].onclick = onThumbnailsClick
			}

			// Parse URL and open gallery if it contains #&pid=3&gid=1
			var hashData = photoswipeParseHash()
			if (hashData.pid && hashData.gid) {
				openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
			}
		}

		//$(document).ready(function(){

		initPhotoSwipeFromDOM('.my-gallery')
		//});

		var pageHasLoaded = false

		$(window).scroll(function() {
			if (pageHasLoaded) {
				scrollUpdate()
			}
		})

		//});

		scrollUpdate()
		pageHasLoaded = true
		loadAllImages()
		//};

		function scrollUpdate() {
			if ($('#ABOUT_PAGE').length) {
				//Window Variables
				var windowTop = $(window).scrollTop()
				var windowHeight = $(window).height()
				var windowBottom = windowTop + windowHeight

				//who
				var who = $('#who')
				var whoBottom = who.offset().top + who.outerHeight() * 0.5

				if (windowBottom > whoBottom) {
					who.addClass('fade-in')
				}

				//Story
				var story = $('.section#story')
				var storyBottom = story.offset().top + story.outerHeight() * 0.5

				if (windowBottom > storyBottom) {
					story.addClass('fade-in')
				}

				//Mission
				var mission = $('.section#mission')
				var missionBottom = mission.offset().top + mission.outerHeight() * 0.5

				if (windowBottom > missionBottom) {
					mission.addClass('fade-in')
				}
				//else { definesUs.children().removeClass("fade-in"); }

				//Membership
				var membership = $('.section#membership')
				var membershipBottom = membership.offset().top + membership.outerHeight() * 0.5

				if (windowBottom > membershipBottom) {
					membership.addClass('fade-in')
				}

				//Team Tab
				var teamTab = $('#team-tab')
				var teamTabBottom = teamTab.offset().top + teamTab.outerHeight() * 0.5

				if (windowBottom > teamTabBottom) {
					teamTab.addClass('slide-in')
				}

				//Directors
				var directors = $('.gallery#directors')
				var directorsBottom = directors.offset().top // + directors.outerHeight() * 0.25;

				if (windowBottom > directorsBottom) {
					directors.addClass('fade-in')
				}

				//Players
				// var players = $('.gallery#players')
				// var playersBottom = players.offset().top // + players.outerHeight() * 0.25;

				// if (windowBottom > playersBottom) {
				// 	players.addClass('fade-in')
				// }

				//Support
				var support = $('.gallery#support')
				var supportBottom = support.offset().top // + support.outerHeight() * 0.25;

				if (windowBottom > supportBottom) {
					support.addClass('fade-in')
				}
			}
		}

		function loadAllImages() {
			var allImages = $('img[delayedsrc]')

			//Start All Images Loading
			allImages.each(function() {
				$(this).attr('src', $(this).attr('delayedsrc'))
			})
		}
	}
	render() {
		return (
			<div id='ABOUT_PAGE'>
				<header className='header' id='header'>
					<img
						src={images.about_header}
						alt='background'
						width='100%'
						height='100%'
						className='header-img'
					/>
					<h1 className='header-txt' id='who'>
						Who We Are
					</h1>
				</header>
				<div className='section' id='story'>
					<div className='column left'>
						<h3>
							OUR STORY
							<br />
							<div className='underline' />
						</h3>
					</div>
					<div className='column right'>
						<p>
							Founded in 2003, the Retired Professional Football Players of Chicago
							(RPFPC) is the charitable arm of the NFL Players Association, Former
							Players - Chicago Chapter. Established as a 501(c)(3) not-for-profit
							organization, the RPFPC is comprised of former professional football
							players who work voluntarily to support Chicagoland causes and
							charities. RPFPC primarily aims to raise funds for its annual academic
							scholarship program and football equipment grant program for local
							youth.
						</p>
						<p>
							The NFL Players Association, Former Players - Chicago Chapter is one of
							33 former NFL players chapters in the nation. The primary function of
							the organization is to serve as a support system to former players and
							help members transition from their playing careers to life after
							football. The organization also aims to leverage its platform for the
							greater good and give back to the local community. In 2012, the Chicago
							Chapter was voted "Chapter of the Year" for its outstanding charitable
							work within the Chicagoland community.
						</p>
					</div>
				</div>
				<div className='section' id='mission'>
					<div className='column left'>
						<h3>
							MISSION STATEMENT
							<br />
							<div className='underline' />
						</h3>
					</div>
					<div className='column right'>
						<p>
							RPFPC aims to support local youth academically and athletically through
							charitable endeavors. Through regular engagement and interaction, we are
							proud to give back to the community that has shown our players and
							members tremendous support over the years both on and off the field,
							while setting the standard for other chapters across the nation. Most
							importantly, we are committed to developing and strengthening our
							programs, which provide youth with safe and proper playing equipment and
							support college tuition costs to ensure the academic and athletic
							success of deserving young individuals.
						</p>
					</div>
				</div>
				<div className='section' id='membership'>
					<div className='column left'>
						<h3>
							FREE MEMBERSHIP
							<br />
							<div className='underline' />
						</h3>
					</div>
					<div className='column right'>
						<p>
							The NFLPA established the Former Player Services Department (FPSD) in
							1984 to provide an active voice within the organization for all former
							professional football players. As a former player, you have an entire
							department at the NFLPA dedicated to your needs, facilitated through
							your local chapter. Members of the NFLPA and RPFPC will have access to a
							number of exclusive benefits and resources, complimentary and discounted
							services, assistance in navigating the Professional Athletes Foundation
							and Players Assistance Trust, networking opportunities, lifetime of
							advocacy and empowerment, and more.
						</p>
						<a
							href='https://www.nflpa.com/former-players/register'
							target='_blank'
							className='button'
							rel='noopener noreferrer'
						>
							Activate Free Membership
						</a>
					</div>
				</div>
				<div className='section team-tab' id='team-tab'>
					<div className='white-background' />
					<div className='red-background'>
						<div className='black-inner' />
						<h2>MEETING THE TEAM</h2>
					</div>
				</div>
				<div className='gallery-container section'>
					<div className='gallery' id='directors'>
						<div className='column left'>
							<h3>
								Board &amp; Officers
								<br />
								<div className='underline' />
							</h3>
						</div>
						<div
							className='my-gallery'
							itemScope='itemScope'
							itemType='http://schema.org/ImageGallery'
						>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.WendellDavis2}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.WendellDavis2}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Wendell Davis | President
								</figcaption>
								<div className='name'>Wendell Davis</div>
								<div className='title'>President</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.BrentNovoselsky2}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.BrentNovoselsky2}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Brent Novoselsky | Vice President
								</figcaption>
								<div className='name'>Brent Novoselsky</div>
								<div className='title'>Vice President</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.ReggieSmith}
									itemProp='contentUrl'
									data-size='275x275'
								>
									<img
										src='#'
										delayedsrc={images.headshots.ReggieSmith}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Reggie Smith | Vice President | Chairman - Celebrity Golf Outing
								</figcaption>
								<div className='name'>Reggie Smith</div>
								<div className='title'>
									Vice President
									<br />
									Chairman - Celebrity Golf Outing
								</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.GregBloedorn2}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.GregBloedorn2}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Greg Bloedorn | Chairman - Scholarship Program
								</figcaption>
								<div className='name'>Greg Bloedorn</div>
								<div className='title'>Chairman - Scholarship Program</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.TomSerpento2}
									itemProp='contentUrl'
									data-size='358x358'
								>
									<img
										src='#'
										delayedsrc={images.headshots.TomSerpento2}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Tom Serpento | Executive Director &amp; Chairman - Grant Program
								</figcaption>
								<div className='name'>Tom Serpento</div>
								<div className='title'>
									Executive Director <br /> Chairman - Grant Program
								</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.ShaferSuggs}
									itemProp='contentUrl'
									data-size='212x211'
								>
									<img
										src='#'
										delayedsrc={images.headshots.ShaferSuggs}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Shafer Suggs | Vice President
								</figcaption>
								<div className='name'>Shafer Suggs</div>
								<div className='title'>Vice President</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.MarquesSullivan}
									itemProp='contentUrl'
									data-size='212x211'
								>
									<img
										src='#'
										delayedsrc={images.headshots.MarquesSullivan}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Marques Sullivan | Vice President | Chairman - Pro Bowl
									Fundraiser
								</figcaption>
								<div className='name'>Marques Sullivan</div>
								<div className='title'>
									Vice President
									<br />
									Chairman - Pro Bowl Fundraiser
								</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.PaulErnster}
									itemProp='contentUrl'
									data-size='300x300'
								>
									<img
										src='#'
										delayedsrc={images.headshots.PaulErnster}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Paul Ernster | Treasurer
								</figcaption>
								<div className='name'>Paul Ernster</div>
								<div className='title'>Treasurer</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.BillSchick}
									itemProp='contentUrl'
									data-size='300x300'
								>
									<img
										src='#'
										delayedsrc={images.headshots.BillSchick}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Bill Schick | Secretary
								</figcaption>
								<div className='name'>Bill Schick</div>
								<div className='title'>Secretary</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.DariusFleming}
									itemProp='contentUrl'
									data-size='300x300'
								>
									<img
										src='#'
										delayedsrc={images.headshots.DariusFleming}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Darius Fleming | Vice President &amp; New Member Committee
								</figcaption>
								<div className='name'>Darius Fleming</div>
								<div className='title'>
									Vice President
									<br />
									New Member Committee
								</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.JustinStaples}
									itemProp='contentUrl'
									data-size='300x300'
								>
									<img
										src='#'
										delayedsrc={images.headshots.JustinStaples}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Justin Staples | New Member Committee
								</figcaption>
								<div className='name'>Justin Staples</div>
								<div className='title'>New Member Committee</div>
							</figure>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.JanetWagner}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.JanetWagner}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Janet Wagner | General Counsel
								</figcaption>
								<div className='name'>Janet Wagner</div>
								<div className='title'>General Counsel</div>
							</figure>
						</div>
					</div>
					{/*<div className="gallery" id="players">
						<div className="column left">
							<h3>
								Former Player Membership Committee
								<br />
								<div className="underline" />
							</h3>
						</div>
						<div
							className="my-gallery"
							itemScope="itemScope"
							itemType="http://schema.org/ImageGallery"
						>
							<figure
								itemProp="associatedMedia"
								itemScope="itemScope"
								itemType="http://schema.org/ImageObject"
							>
								<a
									href={images.headshots.ChandlerHarnish}
									itemProp="contentUrl"
									data-size="400x400"
								>
									<img
										src="#"
										delayedsrc={images.headshots.ChandlerHarnish}
										itemProp="thumbnail"
										alt="description"
									/>
								</a>
								<figcaption itemProp="caption description">
									Chandler Harnish
								</figcaption>
								<div className="name">Chandler Harnish</div>
								<div className="title" />
							</figure>
							<figure
								itemProp="associatedMedia"
								itemScope="itemScope"
								itemType="http://schema.org/ImageObject"
							>
								<a
									href={images.headshots.OliverGibson}
									itemProp="contentUrl"
									data-size="253x253"
								>
									<img
										src="#"
										delayedsrc={images.headshots.OliverGibson}
										itemProp="thumbnail"
										alt="Oliver Gibson"
										title="Oliver Gibson"
									/>
								</a>
								<figcaption itemProp="caption description">
									Oliver Gibson
								</figcaption>
								<div className="name">Oliver Gibson</div>
								<div className="title" />
							</figure>
						</div>
					</div>*/}
					<div className='gallery' id='support'>
						<div className='column left'>
							<h3>
								Support Staff
								<br />
								<div className='underline' />
							</h3>
						</div>
						<div
							className='my-gallery'
							itemScope='itemScope'
							itemType='http://schema.org/ImageGallery'
						>
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.MartriceCaldwell}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.MartriceCaldwell}
										itemProp='thumbnail'
										alt='description'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Martrice Caldwell | Senior Accountant
								</figcaption>
								<div className='name'>Martrice Caldwell</div>
								<div className='title'>Senior Accountant</div>
							</figure>
							{/*       <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.headshots.MykalaSandifer} itemprop="contentUrl" data-size="400x400"><img src="#" delayedsrc={images.headshots.MykalaSandifer} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Martrice Caldwell | Program Assistant</figcaption>
			<div class="name">Mykala Sandifer</div>
			<div class="title">Program Assistant</div>
		  </figure>*/}
							<figure
								itemProp='associatedMedia'
								itemScope='itemScope'
								itemType='http://schema.org/ImageObject'
							>
								<a
									href={images.headshots.LaurenSantee}
									itemProp='contentUrl'
									data-size='400x400'
								>
									<img
										src='#'
										delayedsrc={images.headshots.LaurenSantee}
										itemProp='thumbnail'
										alt='Lauren Santee'
										title='Lauren Santee'
									/>
								</a>
								<figcaption itemProp='caption description'>
									Lauren Santee | Social Media Coordinator
								</figcaption>
								<div className='name'>Lauren Santee</div>
								<div className='title'>Social Media Coordinator</div>
							</figure>
						</div>
					</div>
				</div>
				{/* Root element of PhotoSwipe. Must have class pswp. */}
				<div className='pswp' tabIndex={-1} role='dialog' aria-hidden='true'>
					{/* Background of PhotoSwipe.
	  It's a separate element as animating opacity is faster than rgba(). */}
					<div className='pswp__bg' />
					{/* Slides wrapper with overflow:hidden. */}
					<div className='pswp__scroll-wrap'>
						{/* Container that holds slides.
				PhotoSwipe keeps only 3 of them in the DOM to save memory.
				Don't modify these 3 pswp__item elements, data is added later on. */}
						<div className='pswp__container'>
							<div className='pswp__item' />
							<div className='pswp__item' />
							<div className='pswp__item' />
						</div>
						{/* Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. */}
						<div className='pswp__ui pswp__ui--hidden'>
							<div className='pswp__top-bar'>
								{/* Controls are self-explanatory. Order can be changed. */}
								<div className='pswp__counter' />
								<button
									className='pswp__button pswp__button--close'
									title='Close (Esc)'
								/>
								<button
									className='pswp__button pswp__button--share'
									title='Share'
								/>
								<button
									className='pswp__button pswp__button--fs'
									title='Toggle fullscreen'
								/>
								<button
									className='pswp__button pswp__button--zoom'
									title='Zoom in/out'
								/>{' '}
								{/* Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR */}
								{/* element will get class pswp__preloader--active when preloader is running */}
								<div className='pswp__preloader'>
									<div className='pswp__preloader__icn'>
										<div className='pswp__preloader__cut'>
											<div className='pswp__preloader__donut' />
										</div>
									</div>
								</div>
							</div>
							<div className='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
								<div className='pswp__share-tooltip' />
							</div>
							<button
								className='pswp__button pswp__button--arrow--left'
								title='Previous (arrow left)'
							/>
							<button
								className='pswp__button pswp__button--arrow--right'
								title='Next (arrow right)'
							/>
							<div className='pswp__caption'>
								<div className='pswp__caption__center' />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default About
